import { createHttpService } from 'src/apis/ApiService';
import { TPaginationParams } from 'src/apis/__shared/shared.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

export type GuardianDashboardData = {
  studentId: string;
  summary: {
    attendance: {
      present: number;
      absent: number;
      percentage: number;
    };
    academics: {
      averageScore: number;
      recentAssessments: number;
    };
    fees: {
      pending: number;
      paid: number;
    };
  };
};

const useGuardianDashboardService = () => {
  const httpAPI = createHttpService();
  const baseGuardianPath = '/guardian/dashboard';
  const withMockData = isAppWithMock();

  const getDashboardData = (
    studentId: string,
    params?: TPaginationParams
  ): Promise<GuardianDashboardData> => {
    if (withMockData) {
      return Promise.resolve({
        studentId,
        summary: {
          attendance: {
            present: 85,
            absent: 5,
            percentage: 94.4,
          },
          academics: {
            averageScore: 87.5,
            recentAssessments: 3,
          },
          fees: {
            pending: 5000,
            paid: 15000,
          },
        },
      });
    }

    const requestObj = {
      params: {
        studentId,
        ...(params?.page && { page: Number(params.page) }),
        ...(params?.limit && { limit: Number(params.limit) }),
      },
    };

    return httpAPI
      .get<GuardianDashboardData>(baseGuardianPath, requestObj)
      .then((response) => response)
      .catch((error) => {
        console.error('Error fetching guardian dashboard data:', error);
        throw error;
      });
  };

  return {
    getDashboardData,
  };
};

export default useGuardianDashboardService;
